module.exports = __webpack_public_path__ + "static/media/statistics.cd8fde08.svg";